export const AGE_VERIFICATION_FOR_SSC = false
export const IS_LAST_PAYMENT_ENABLED = true
export const IS_SHOW_DOB = false
export const IS_GUEST_ENABLED = true
export const IS_SHOW_SHIPMENT_LINKS = true
export const IS_BLOG_ENABLED = true
export const STOCK_STATUS_CLICKABLE = false
export const IS_DEFAULT_BREADCRUMB_ENABLED = false
export const GUEST_GTM_EVENT = true
export const IS_STORE_CREDIT_ENABLED = false
export const TERMS_LINK = 'content/terms-and-conditions'
export const PRIVACY_LINK = 'content/privacy-policy'
export const IS_YOUTUBE_SEO_ENABLED = false
export const IS_CHECKOUT_AGREEMENTS = false
export const IS_SEPARATE_PAGE = true
export const IS_SUBSCRIPTION_ENABLED = false
export const IS_AGE_VERFICATION_ON_ACCOUNT_PAGE = false
export const ALL_BRAND_PAGE_URL = 'shop-by-brand'
